
<script>
import CreateItem from "./create-item";

export default {
  name: "create-item-modal",
  props:["route","plans"],
  methods:{
    showCreatePlanModal(){
      $("#itemModal").modal("show")
      // this.$modal.show(CreateItem,{route: this.route, plans: this.plans},{name:"create-item",width: 500, height:700, adaptive})
    }
  }
}
</script>

<style scoped>

</style>